import AppDispatcher from '../AppDispatcher';
import Remote from '../Remote';

const QuoteFeedSymbolsStore = {
  _symbols: [],

  getSymbols: function (feedId) {
    return this._symbols.filter(
      symbol => symbol.FeedId === feedId
        // && symbol.Status !== 2
    );
  },

  get: function (symbolId) {
    return this._symbols.find(symbol => symbol.Id === symbolId) || null;
  },

  emitChange: function () {
    this.trigger(Constants.ActionTypes.QUOTE_FEED_SYMBOLS.UPDATE);
  },

  /**
   * @param {function} callback
   */
  addChangeListener: function (callback) {
    this.bind(Constants.ActionTypes.QUOTE_FEED_SYMBOLS.UPDATE, callback);
  },

  removeChangeListener: function (callback) {
    this.unbind(Constants.ActionTypes.QUOTE_FEED_SYMBOLS.UPDATE, callback);
  },

  handleDispatcher: function (action) {
    switch (action.actionType) {
      case Constants.ActionTypes.QUOTE_FEED_SYMBOLS.UPDATE:
        Remote.quoteFeedSymbolsGet(response => {
          this._symbols = response.Result.FeedSymbols;
          this.emitChange();
        });
        break;
      case Constants.ActionTypes.QUOTE_FEED_SYMBOLS.SET:
        this._symbols = action.items;
        this.emitChange();
        break;
    }
  }
};

MicroEvent.mixin(QuoteFeedSymbolsStore);

AppDispatcher.register(QuoteFeedSymbolsStore.handleDispatcher.bind(QuoteFeedSymbolsStore));

export default QuoteFeedSymbolsStore;



// WEBPACK FOOTER //
// ./src/js/Stores/QuoteFeedSymbolsStore.js